import { debounce } from "lodash";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { actions, Form } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import {
    PersonnelRoleBreadcrumbs,
    PersonnelRoleCreateBreadcrumbs,
} from "src/helpers/breadcrumbHelper";
import useNavigate from "src/hooks/useNavigate";
import * as InstitutionLaboratoryActions from "../../../actions/institutionLaboratory";
import * as NavigationActions from "../../../actions/navigation";
import * as PersonnelActions from "../../../actions/personnel";
import * as PersonnelRoleActions from "../../../actions/personnelRole";
import * as TrialGroupActions from "../../../actions/trialGroup";
import * as TrialGroupLaboratoryActions from "../../../actions/trialGroupLaboratory";
import * as TrialInstitutionActions from "../../../actions/trialInstitution";
import * as TrialInstitutionLaboratoryActions from "../../../actions/trialInstitutionLaboratory";
import { NotificationAlert } from "../../../components/common/index";
import {
    CheckboxFormInput,
    DatePickerFormInputFabric,
    SelectFormInput,
} from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import {
    findLookup,
    generateOptionsFromLookup,
} from "../../../helpers/lookupHelper";
import {
    PersonnelRoleSubMenu,
    PersonnelSubMenu,
} from "../../../helpers/subMenuHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import { IPersonnelRoleReduxFormState } from "../../../reducers/reactReduxForms/personnelRole";

import "./PersonnelRolePage.scss";

interface PersonnelRolePageProps {
    form: Dtos.PersonnelRole & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IPersonnelRoleReduxFormState;
    personnelRole: Dtos.PersonnelRole;
    personnel: Dtos.Personnel;
    lookups: Dtos.Lookup[];
    loadingPersonnel: boolean;
    loadPersonnelSuccess: boolean;
    loadPersonnelFailure: boolean;
    loadPersonnelErrorCode: string;
    loadingPersonnelRole: boolean;
    loadPersonnelRoleSuccess: boolean;
    loadPersonnelRoleFailure: boolean;
    loadPersonnelRoleErrorCode: string;
    savingPersonnelRole: boolean;
    savePersonnelRoleSuccess: boolean;
    savePersonnelRoleFailure: boolean;
    creatingPersonnelRole: boolean;
    createPersonnelRoleSuccess: boolean;
    createPersonnelRoleFailure: boolean;
    validatingPersonnelRole: boolean;
    validationFailures: Dtos.ResponseError[];
    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    trialInstitutions: Dtos.TrialInstitution[];
    loadingTrialInstitutions: boolean;
    trialGroups: Dtos.TrialGroup[];
    loadingTrialGroups;
    institutionLaboratories: Dtos.InstitutionLaboratory[];
    loadingInstitutionLaboratories: boolean;
    trialInstitutionLaboratories: Dtos.TrialInstitutionLaboratory[];
    loadingTrialInstitutionLaboratories: boolean;
    trialGroupLaboratories: Dtos.TrialGroupLaboratory[];
    loadingTrialGroupLaboratories: boolean;
    clearPersonnelRole: PersonnelRoleActions.IPersonnelRoleClearActionCreator;
    loadPersonnelRole: PersonnelRoleActions.IPersonnelRoleLoadByIdActionCreator;
    savePersonnelRole: PersonnelRoleActions.IPersonnelRoleSaveActionCreator;
    createPersonnelRole: PersonnelRoleActions.IPersonnelRoleCreateActionCreator;
    validatePersonnelRole: PersonnelRoleActions.IPersonnelRoleValidateActionCreator;
    clearPersonnel: PersonnelActions.IPersonnelClearActionCreator;
    loadPersonnel: PersonnelActions.IPersonnelLoadByIdActionCreator;
    clearTrialInstitutions: TrialInstitutionActions.ITrialInstitutionClearActionCreator;
    loadTrialInstitutions: TrialInstitutionActions.ITrialInstitutionLoadActionCreator;
    clearTrialGroups: TrialGroupActions.ITrialGroupClearActionCreator;
    loadTrialGroups: TrialGroupActions.ITrialGroupLoadActionCreator;
    clearInstitutionLaboratories: InstitutionLaboratoryActions.IInstitutionLaboratoryClearActionCreator;
    loadInstitutionLaboratories: InstitutionLaboratoryActions.IInstitutionLaboratoriesLoadActionCreator;
    clearTrialInstitutionLaboratories: TrialInstitutionLaboratoryActions.ITrialInstitutionLaboratoryClearActionCreator;
    loadTrialInstitutionLaboratories: TrialInstitutionLaboratoryActions.ITrialInstitutionLaboratoriesLoadActionCreator;
    clearTrialGroupLaboratories: TrialGroupLaboratoryActions.ITrialGroupLaboratoryClearActionCreator;
    loadTrialGroupLaboratories: TrialGroupLaboratoryActions.ITrialGroupLaboratoriesLoadActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
}

const reduxFormName: string = "reduxForms.personnelRole";

const PersonnelRolePage: FC<PersonnelRolePageProps> = ({
    form,
    formState,
    formProperties,
    personnelRole,
    personnel,
    lookups,
    loadingPersonnel,
    loadPersonnelFailure,
    loadPersonnelErrorCode,
    loadingPersonnelRole,
    loadPersonnelRoleFailure,
    loadPersonnelRoleErrorCode,
    savingPersonnelRole,
    savePersonnelRoleSuccess,
    savePersonnelRoleFailure,
    creatingPersonnelRole,
    createPersonnelRoleSuccess,
    validatingPersonnelRole,
    validationFailures,
    permissions,
    trialInstitutions,
    loadingTrialInstitutions,
    trialGroups,
    loadingTrialGroups,
    institutionLaboratories,
    loadingInstitutionLaboratories,
    trialInstitutionLaboratories,
    loadingTrialInstitutionLaboratories,
    trialGroupLaboratories,
    loadingTrialGroupLaboratories,
    clearPersonnelRole,
    loadPersonnelRole,
    savePersonnelRole,
    createPersonnelRole,
    validatePersonnelRole,
    clearPersonnel,
    loadPersonnel,
    clearTrialInstitutions,
    loadTrialInstitutions,
    clearTrialGroups,
    loadTrialGroups,
    clearInstitutionLaboratories,
    loadInstitutionLaboratories,
    clearTrialInstitutionLaboratories,
    loadTrialInstitutionLaboratories,
    clearTrialGroupLaboratories,
    loadTrialGroupLaboratories,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems
}) => {
    //
    // -- Params --
    const { personnelId } = useParams<{ personnelId: string }>();
    const { personnelRoleId } = useParams<{ personnelRoleId: string }>();
    const personnelIdNumber = parseInt(personnelId, 10);
    const personnelRoleIdNumber = parseInt(personnelRoleId, 10);

    //
    // -- Hooks --
    const navigate = useNavigate();

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [initalised, setInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    const loadReduxForm = () => {
        let extraData: Dtos.PersonnelRole = {} as Dtos.PersonnelRole;

        loadForm(reduxFormName, Object.assign({ ...personnelRole }, extraData));
    };


    // Load personnel role
    useEffect(() => {
        if (
            personnelIdNumber &&
            personnelRoleIdNumber &&
            !personnelRole &&
            !loadingPersonnelRole &&
            !personnel &&
            !loadingPersonnel
        ) {
            setDrawerItems(
                PersonnelRoleSubMenu(
                    personnelIdNumber,
                    personnelRoleIdNumber,
                    permissions
                )
            );
            setBreadcrumbs(
                PersonnelRoleBreadcrumbs(
                    personnelIdNumber,
                    personnelRoleIdNumber
                )
            );
            loadPersonnelRole(personnelRoleIdNumber);
            loadPersonnel(personnelIdNumber);
            loadTrialInstitutions();
            loadTrialGroups();
            loadInstitutionLaboratories();
            loadTrialInstitutionLaboratories();
            loadTrialGroupLaboratories();
        } else if (
            personnelIdNumber &&
            !personnelRoleIdNumber &&
            !creatingPersonnelRole &&
            !createPersonnelRoleSuccess
        ) {
            createPersonnelRole(null, null, null, null, null, null);
            loadPersonnel(personnelIdNumber);
            loadTrialInstitutions();
            loadTrialGroups();
            loadInstitutionLaboratories();
            loadTrialInstitutionLaboratories();
            loadTrialGroupLaboratories();
            setBreadcrumbs(PersonnelRoleCreateBreadcrumbs(personnelIdNumber));
            setDrawerItems([]);
        } else if (personnelRole && !initalised) {
            loadReduxForm();
            setInitalised(true);
        }
    }, [
        personnelIdNumber,
        personnelRoleIdNumber,
        personnelRole,
        setDrawerItems,
        PersonnelSubMenu,
        permissions,
        setBreadcrumbs,
        PersonnelRoleBreadcrumbs,
        loadPersonnelRole,
        createPersonnelRole,
        initalised,
        setInitalised,
        loadReduxForm,
        loadingPersonnelRole,
        creatingPersonnelRole,
        createPersonnelRoleSuccess,
        PersonnelRoleCreateBreadcrumbs,
        loadTrialInstitutions,
        loadTrialGroups,
        loadInstitutionLaboratories,
        loadTrialInstitutionLaboratories,
        loadTrialGroupLaboratories,
    ]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadPersonnelFailure) {
            navigate(`/error/${loadPersonnelErrorCode}`);
        }
        if (loadPersonnelRoleFailure) {
            navigate(`/error/${loadPersonnelRoleErrorCode}`);
        }
    }, [
        loadPersonnelFailure,
        loadPersonnelRoleFailure,
        loadPersonnelErrorCode,
        loadPersonnelRoleErrorCode,
        navigate,
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (
            personnelIdNumber &&
            personnelRoleIdNumber &&
            personnel &&
            personnelRole
        ) {
            setBreadcrumbs(
                PersonnelRoleBreadcrumbs(
                    personnelIdNumber,
                    personnelRoleIdNumber,
                    `${personnel.firstName} ${personnel.lastName}`,
                    personnelRole.roleDisplay
                )
            );
        } else if (personnelIdNumber && !personnelRoleIdNumber && personnel) {
            if (personnel?.firstName && personnel?.lastName) {
                setBreadcrumbs(
                    PersonnelRoleCreateBreadcrumbs(
                        personnelIdNumber,
                        `${personnel.firstName} ${personnel.lastName}`
                    )
                );
            }
        }
    }, [
        personnelIdNumber,
        personnelRoleIdNumber,
        personnel,
        personnelRole,
        setBreadcrumbs,
        PersonnelRoleBreadcrumbs,
        PersonnelRoleCreateBreadcrumbs,
    ]);

    // Reload personnel role after saving
    useEffect(() => {
        if (!savingPersonnelRole && savePersonnelRoleSuccess) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Personnel role saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                let url: string = `/personnel/${personnelIdNumber}/roles`;
                navigate(url);
            } else if (!personnelRoleIdNumber) {
                let url: string = `/personnel/${personnelIdNumber}/roles/${personnelRole?.id}/details`;
                navigate(url);
                clearPersonnel();
                clearPersonnelRole();
                clearTrialInstitutions();
                clearTrialGroups();
                clearInstitutionLaboratories();
                clearTrialInstitutionLaboratories();
                clearTrialGroupLaboratories();
            }
        }
    }, [
        savingPersonnelRole,
        savePersonnelRoleSuccess
    ]);

    // Failed saving
    useEffect(() => {
        if (!savingPersonnelRole && savePersonnelRoleFailure) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [savingPersonnelRole, savePersonnelRoleFailure]);

    // Cleanup effect to clear the personnel & personnel role on component unmount
    useEffect(() => {
        return () => {
            clearPersonnel();
            clearPersonnelRole();
            clearTrialInstitutions();
            clearTrialGroups();
            clearInstitutionLaboratories();
            clearTrialInstitutionLaboratories();
            clearTrialGroupLaboratories();
            resetForm(reduxFormName);
        };
    }, [
        clearPersonnel,
        clearPersonnelRole,
        clearTrialInstitutions,
        clearTrialGroups,
        clearInstitutionLaboratories,
        clearTrialInstitutionLaboratories,
        clearTrialGroupLaboratories,
        resetForm,
        reduxFormName,
    ]);

    const onCancel = () => {
        let url: string = `/personnel/${personnel?.id}/roles`;
        navigate(url);
    };

    const handleOnSubmitFailed = (_data: Dtos.PersonnelRole) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.PersonnelRole = {
                personnelId: personnelIdNumber,
            } as Dtos.PersonnelRole;

            if (
                data?.trialId &&
                data?.laboratoryId &&
                !data?.groupId &&
                !data?.institutionId
            ) {
                changes.laboratoryId = null;
            }

            await savePersonnelRole(Object.assign({ ...data }, changes));

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.PersonnelRole = {} as Dtos.PersonnelRole;

            if (form && hasBeenSubmitted && !validatingPersonnelRole) {
                await validatePersonnelRole(
                    Object.assign({ ...form }, changes)
                );
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    // Dropdown options memos
    const trialSelectOptions = useMemo(() => {
        if (form.institutionId && !form.laboratoryId && trialInstitutions) {
            return trialInstitutions
                ?.filter((x) => x.institutionId == form.institutionId)
                ?.sort((a, b) =>
                    a?.trial?.displayName.localeCompare(b?.trial?.displayName)
                )
                ?.map((x) => ({
                    value: x.trialId,
                    label: x?.trial?.displayName,
                }));
        } else if (
            form.institutionId &&
            form.laboratoryId &&
            trialInstitutionLaboratories
        ) {
            return trialInstitutionLaboratories
                ?.filter(
                    (x) =>
                        x?.trialInstitution?.institutionId ==
                            form.institutionId &&
                        x.laboratoryId == form.laboratoryId
                )
                ?.sort((a, b) =>
                    a?.trialInstitution?.trial?.displayName.localeCompare(
                        b?.trialInstitution?.trial?.displayName
                    )
                )
                ?.map((x) => ({
                    value: x?.trialInstitution?.trialId,
                    label: x?.trialInstitution?.trial?.displayName,
                }));
        } else if (form.groupId && !form.laboratoryId && trialGroups) {
            return trialGroups
                ?.filter((x) => x.groupId == form.groupId)
                ?.sort((a, b) =>
                    a?.trial?.displayName.localeCompare(b?.trial?.displayName)
                )
                ?.map((x) => ({
                    value: x?.trialId,
                    label: x?.trial?.displayName,
                }));
        } else if (
            form.groupId &&
            form.laboratoryId &&
            trialGroupLaboratories
        ) {
            return trialGroupLaboratories
                ?.filter(
                    (x) =>
                        x?.trialGroup?.groupId == form.groupId &&
                        x.laboratoryId == form.laboratoryId
                )
                ?.sort((a, b) =>
                    a?.trialGroup?.trial?.displayName.localeCompare(
                        b?.trialGroup?.trial?.displayName
                    )
                )
                ?.map((x) => ({
                    value: x?.trialGroup?.trialId,
                    label: x?.trialGroup?.trial?.displayName,
                }));
        }
        return generateOptionsFromLookup(
            findLookup("PersonnelRole", "trialId", lookups),
            form.trialId
        );
    }, [
        form,
        trialInstitutions,
        trialGroups,
        trialInstitutionLaboratories,
        trialGroupLaboratories,
    ]);

    const institutionSelectOptions = useMemo(() => {
        if (form.trialId && !form.institutionId && trialInstitutions) {
            return trialInstitutions
                ?.filter((x) => x.trialId == form.trialId)
                ?.sort((a, b) =>
                    a?.institution?.name.localeCompare(b?.institution?.name)
                )
                ?.map((x) => ({
                    value: x.institutionId,
                    label: x?.institution?.name,
                }));
        } else if (
            form.trialId &&
            form.laboratoryId &&
            trialInstitutionLaboratories
        ) {
            return trialInstitutionLaboratories
                ?.filter(
                    (x) =>
                        x?.trialInstitution?.trialId == form.trialId &&
                        x.laboratoryId == form.laboratoryId
                )
                ?.sort((a, b) =>
                    a?.trialInstitution?.institution?.name.localeCompare(
                        b?.trialInstitution?.institution?.name
                    )
                )
                ?.map((x) => ({
                    value: x?.trialInstitution?.institutionId,
                    label: x?.trialInstitution?.institution?.name,
                }));
        } else if (form.laboratoryId && institutionLaboratories) {
            return institutionLaboratories
                ?.filter((x) => x.laboratoryId == form.laboratoryId)
                ?.sort((a, b) =>
                    a?.institution?.name.localeCompare(b?.institution?.name)
                )
                ?.map((x) => ({
                    value: x.institutionId,
                    label: x?.institution?.name,
                }));
        }
        return generateOptionsFromLookup(
            findLookup("PersonnelRole", "institutionId", lookups),
            form.institutionId
        );
    }, [
        form,
        trialInstitutions,
        institutionLaboratories,
        trialInstitutionLaboratories,
    ]);

    const groupSelectOptions = useMemo(() => {
        if (form.trialId && !form.laboratoryId && trialGroups) {
            return trialGroups
                ?.filter((x) => x.trialId == form.trialId)
                ?.sort((a, b) => a?.group?.name.localeCompare(b?.group?.name))
                ?.map((x) => ({ value: x?.groupId, label: x?.group?.name }));
        }
        if (form.trialId && form.laboratoryId && trialGroupLaboratories) {
            return trialGroupLaboratories
                ?.filter(
                    (x) =>
                        x?.trialGroup?.trialId == form.trialId &&
                        x.laboratoryId == form.laboratoryId
                )
                ?.sort((a, b) =>
                    a?.trialGroup?.group?.name.localeCompare(
                        b?.trialGroup?.group?.name
                    )
                )
                ?.map((x) => ({
                    value: x?.trialGroup?.groupId,
                    label: x?.trialGroup?.group?.name,
                }));
        }
        return generateOptionsFromLookup(
            findLookup("PersonnelRole", "groupId", lookups),
            form.groupId
        );
    }, [form, trialGroups, trialGroupLaboratories]);

    const laboratorySelectOptions = useMemo(() => {
        if (
            form.institutionId &&
            !form.trialId &&
            !form.groupId &&
            institutionLaboratories
        ) {
            return institutionLaboratories
                ?.filter((x) => x.institutionId == form.institutionId)
                ?.sort((a, b) =>
                    a?.laboratory?.name.localeCompare(b?.laboratory?.name)
                )
                ?.map((x) => ({
                    value: x.laboratoryId,
                    label: x?.laboratory?.name,
                }));
        } else if (
            form.trialId &&
            form.institutionId &&
            !form.groupId &&
            trialInstitutionLaboratories
        ) {
            return trialInstitutionLaboratories
                ?.filter(
                    (x) =>
                        x?.trialInstitution?.trialId == form.trialId &&
                        x.trialInstitution?.institutionId == form.institutionId
                )
                ?.sort((a, b) =>
                    a?.laboratory?.name.localeCompare(b?.laboratory?.name)
                )
                ?.map((x) => ({
                    value: x?.laboratoryId,
                    label: x?.laboratory?.name,
                }));
        } else if (
            form.trialId &&
            form.groupId &&
            !form.institutionId &&
            trialGroupLaboratories
        ) {
            return trialGroupLaboratories
                ?.filter(
                    (x) =>
                        x?.trialGroup?.trialId == form.trialId &&
                        x.trialGroup?.groupId == form.groupId
                )
                ?.sort((a, b) =>
                    a?.laboratory?.name.localeCompare(b?.laboratory?.name)
                )
                ?.map((x) => ({
                    value: x?.laboratoryId,
                    label: x?.laboratory?.name,
                }));
        }
        return generateOptionsFromLookup(
            findLookup("PersonnelRole", "laboratoryId", lookups),
            form.laboratoryId
        );
    }, [
        form,
        trialInstitutions,
        institutionLaboratories,
        trialInstitutionLaboratories,
        trialGroupLaboratories,
    ]);

    const renderContent = useMemo(() => {
        let noPermissionToEditMessage = false;
        if (
            form.id &&
            form.id > 0 &&
            validationFailures &&
            validationFailures.filter((f) => f.errorCode == "PR-005").length > 0
        ) {
            noPermissionToEditMessage = true;
        }

        let trialDisabled = false;
        let institutionDisabled = false;
        let groupDisabled = false;
        let laboratoryDisabled = false;
        if (form.institutionId) {
            groupDisabled = true;
        }
        if (form.groupId) {
            institutionDisabled = true;
        }
        if (form.trialId && !form.institutionId && !form.groupId) {
            laboratoryDisabled = true;
        }
        if (form.groupId && !form.trialId) {
            laboratoryDisabled = true;
        }

        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermission(
                form,
                permissions,
                Dtos.Permission.PersonnelRoleUpdate,
                Dtos.Permission.PersonnelRoleCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingPersonnelRole ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled) ||
            noPermissionToEditMessage;

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            roleDetails: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Details</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnelRole",
                                        {
                                            roleId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "PersonnelRole",
                                                                "roleId",
                                                                lookups
                                                            ),
                                                            form.roleId
                                                        ),
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0",
                                                labelClassName:
                                                    "col-form-label col-xxl-1 col-xl-2",
                                                fieldClassName:
                                                    "col-xl-10 col-xxl-11 generic-form-field mr-0 pr-0",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-xxl-6 col-xl-12 pb-xl-2 pb-xxl-0">
                                    {renderFormControls(
                                        form,
                                        "personnelRole",
                                        {
                                            dateStarted: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType:
                                                    DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 ",
                                                labelClassName:
                                                    "col-form-label col-2",
                                                fieldClassName:
                                                    "col-xxl-9 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-xxl-6 col-xl-12 pt-xl-2 pt-xxl-0">
                                    {renderFormControls(
                                        form,
                                        "personnelRole",
                                        {
                                            dateCeased: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType:
                                                    DatePickerFormInputFabric,
                                                inputDisabled:
                                                    formDisabled ||
                                                    !form.dateStarted,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-2",
                                                fieldClassName:
                                                    "col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnelRole",
                                        {
                                            active: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: CheckboxFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    label: "Active",
                                                },
                                                inputLabel: " ",
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-xxl-1 col-xl-2",
                                                fieldClassName:
                                                    "col-xxl-11 col-xl-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            associationGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Association</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnelRole",
                                        {
                                            trialId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled:
                                                    formDisabled ||
                                                    trialDisabled,
                                                inputProps: {
                                                    options: trialSelectOptions,
                                                    clearable: true,
                                                    loading:
                                                        loadingTrialInstitutions ||
                                                        loadingTrialGroups ||
                                                        loadingTrialInstitutionLaboratories ||
                                                        loadingTrialGroupLaboratories,
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-xxl-1",
                                                fieldClassName:
                                                    "col-xxl-11 generic-form-field mr-0 pr-0",
                                                changeAction: (
                                                    _model,
                                                    value,
                                                    _form,
                                                    _parentModel
                                                ) => {
                                                    if (
                                                        !value &&
                                                        form.groupId
                                                    ) {
                                                        changeForm(
                                                            reduxFormName +
                                                                ".laboratoryId",
                                                            value
                                                        );
                                                    }
                                                    changeForm(
                                                        reduxFormName +
                                                            ".trialId",
                                                        value
                                                    );
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnelRole",
                                        {
                                            institutionId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled:
                                                    formDisabled ||
                                                    institutionDisabled,
                                                inputProps: {
                                                    options:
                                                        institutionSelectOptions,
                                                    clearable: true,
                                                    loading:
                                                        loadingTrialInstitutions ||
                                                        loadingInstitutionLaboratories ||
                                                        loadingTrialInstitutionLaboratories,
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-xxl-1",
                                                fieldClassName:
                                                    "col-xxl-11 generic-form-field mr-0 pr-0",
                                                changeAction: (
                                                    _model,
                                                    value,
                                                    _form,
                                                    _parentModel
                                                ) => {
                                                    if (value) {
                                                        changeForm(
                                                            reduxFormName +
                                                                ".groupId",
                                                            null
                                                        );
                                                    } else {
                                                        changeForm(
                                                            reduxFormName +
                                                                ".laboratoryId",
                                                            null
                                                        );
                                                    }
                                                    changeForm(
                                                        reduxFormName +
                                                            ".institutionId",
                                                        value
                                                    );
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row py-2 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnelRole",
                                        {
                                            groupId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled:
                                                    formDisabled ||
                                                    groupDisabled,
                                                inputProps: {
                                                    options: groupSelectOptions,
                                                    clearable: true,
                                                    loading:
                                                        loadingTrialGroups ||
                                                        loadingTrialGroupLaboratories,
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-xxl-1",
                                                fieldClassName:
                                                    "col-xxl-11 generic-form-field mr-0 pr-0",
                                                changeAction: (
                                                    _model,
                                                    value,
                                                    _form,
                                                    _parentModel
                                                ) => {
                                                    if (value) {
                                                        changeForm(
                                                            reduxFormName +
                                                                ".institutionId",
                                                            null
                                                        );
                                                    } else {
                                                        changeForm(
                                                            reduxFormName +
                                                                ".laboratoryId",
                                                            null
                                                        );
                                                    }
                                                    changeForm(
                                                        reduxFormName +
                                                            ".groupId",
                                                        value
                                                    );
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-12">
                                    {renderFormControls(
                                        form,
                                        "personnelRole",
                                        {
                                            laboratoryId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: SelectFormInput,
                                                inputDisabled:
                                                    formDisabled ||
                                                    laboratoryDisabled,
                                                inputProps: {
                                                    options:
                                                        laboratorySelectOptions,
                                                    clearable: true,
                                                    loading:
                                                        loadingInstitutionLaboratories ||
                                                        loadingTrialInstitutionLaboratories ||
                                                        loadingTrialGroupLaboratories,
                                                },
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-xxl-1",
                                                fieldClassName:
                                                    "col-xxl-11 generic-form-field mr-0 pr-0",
                                                changeAction: (
                                                    _model,
                                                    value,
                                                    _form,
                                                    _parentModel
                                                ) => {
                                                    changeForm(
                                                        reduxFormName +
                                                            ".laboratoryId",
                                                        value
                                                    );
                                                },
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <Form
                model={reduxFormName}
                onSubmit={(val, _event) => handleOnSubmit(val)}
                onSubmitFailed={(val) => handleOnSubmitFailed(val)}
            >
                {noPermissionToEditMessage && (
                    <>
                        <div className="card card-shadow p-3">
                            <div className="alert alert-warning d-flex mt-2 mb-2">
                                <div className="mr-2">
                                    <FontAwesomeIcon
                                        icon={
                                            FontAwesomeIcons.Solid.INFO_SQUARE
                                        }
                                        fixedWidth
                                    />
                                </div>
                                <span>
                                    You can't edit a role that is higher than
                                    your own.
                                </span>
                            </div>
                        </div>
                        <br />
                    </>
                )}
                {renderFormControls(
                    form,
                    "personnelRole",
                    formComponents,
                    lookups,
                    validationFailures,
                    formProperties,
                    changeForm
                )}
                <div className="mt-4 mb-4 text-right">
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(reduxFormName + ".saveAndReturn", false);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={onCancel} className="btn btn-primary mr-2">
                        Cancel
                    </button>
                </div>
            </Form>
        );
    }, [
        form,
        validationFailures,
        permissions,
        formState,
        generateOptionsFromLookup,
        findLookup,
        handleOnSubmit,
        handleOnSubmitFailed,
        lookups,
        formProperties,
        changeForm,
        loadingTrialInstitutions,
        loadingTrialGroups,
        loadingInstitutionLaboratories,
        loadingTrialInstitutionLaboratories,
        loadingTrialGroupLaboratories,
        trialSelectOptions,
        institutionSelectOptions,
        groupSelectOptions,
        laboratorySelectOptions,
    ]);

    return (
        <RestrictedLayout
            permission={Dtos.Permission.PersonnelRoleView}
            loading={
                loadingPersonnel ||
                loadingPersonnelRole ||
                creatingPersonnelRole
            }
        >
            {renderContent}
        </RestrictedLayout>
    );
};

const mapStateToProps = (state: ITmdState): Partial<PersonnelRolePageProps> => {
    let personnelRole: Dtos.PersonnelRole | undefined = !(
        state.personnelRole.formData instanceof Array
    )
        ? state.personnelRole.formData
        : undefined;
    let personnel: Dtos.Personnel | undefined = !(
        state.personnel.formData instanceof Array
    )
        ? state.personnel.formData
        : undefined;
    let trialInstitutions: Dtos.TrialInstitution[] | undefined =
        state.trialInstitution.formData instanceof Array
            ? state.trialInstitution.formData
            : undefined;
    let trialGroups: Dtos.TrialGroup[] | undefined =
        state.trialGroup.formData instanceof Array
            ? state.trialGroup.formData
            : undefined;
    let institutionLaboratories: Dtos.InstitutionLaboratory[] | undefined =
        state.institutionLaboratory.formData instanceof Array
            ? state.institutionLaboratory.formData
            : undefined;
    let trialInstitutionLaboratories:
        | Dtos.TrialInstitutionLaboratory[]
        | undefined =
        state.trialInstitutionLaboratory.formData instanceof Array
            ? state.trialInstitutionLaboratory.formData
            : undefined;
    let trialGroupLaboratories: Dtos.TrialGroupLaboratory[] | undefined =
        state.trialGroupLaboratory.formData instanceof Array
            ? state.trialGroupLaboratory.formData
            : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        personnelRole: personnelRole!,
        personnel: personnel!,
        trialInstitutions: trialInstitutions!,
        trialGroups: trialGroups!,
        institutionLaboratories: institutionLaboratories!,
        trialInstitutionLaboratories: trialInstitutionLaboratories!,
        trialGroupLaboratories: trialGroupLaboratories!,
        loadingPersonnelRole:
            state.personnelRole.loadState &&
            state.personnelRole.loadState.status == RequestState.Pending,
        loadPersonnelRoleSuccess:
            state.personnelRole.loadState &&
            state.personnelRole.loadState.status == RequestState.Success,
        loadPersonnelRoleFailure:
            state.personnelRole.loadState &&
            state.personnelRole.loadState.status == RequestState.Failure,
        loadPersonnelRoleErrorCode: state.personnelRole.loadState.errorCode,
        savingPersonnelRole:
            state.personnelRole.saveState &&
            state.personnelRole.saveState.status == RequestState.Pending,
        savePersonnelRoleSuccess:
            state.personnelRole.saveState &&
            state.personnelRole.saveState.status == RequestState.Success,
        savePersonnelRoleFailure:
            state.personnelRole.saveState &&
            state.personnelRole.saveState.status == RequestState.Failure,
        creatingPersonnelRole:
            state.personnelRole.createState &&
            state.personnelRole.createState.status == RequestState.Pending,
        createPersonnelRoleSuccess:
            state.personnelRole.createState &&
            state.personnelRole.createState.status == RequestState.Success,
        createPersonnelRoleFailure:
            state.personnelRole.createState &&
            state.personnelRole.createState.status == RequestState.Failure,
        loadingPersonnel:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Pending,
        loadPersonnelSuccess:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Success,
        loadPersonnelFailure:
            state.personnel.loadState &&
            state.personnel.loadState.status == RequestState.Failure,
        loadPersonnelErrorCode: state.personnel.loadState.errorCode,
        validatingPersonnelRole:
            state.personnelRole.validateState &&
            state.personnelRole.validateState.status == RequestState.Pending,
        loadingTrialInstitutions:
            state.trialInstitution.loadState &&
            state.trialInstitution.loadState.status == RequestState.Pending,
        loadingTrialGroups:
            state.trialGroup.loadState &&
            state.trialGroup.loadState.status == RequestState.Pending,
        loadingInstitutionLaboratories:
            state.institutionLaboratory.loadState &&
            state.institutionLaboratory.loadState.status ==
                RequestState.Pending,
        loadingTrialInstitutionLaboratories:
            state.trialInstitutionLaboratory.loadState &&
            state.trialInstitutionLaboratory.loadState.status ==
                RequestState.Pending,
        loadingTrialGroupLaboratories:
            state.trialGroupLaboratory.loadState &&
            state.trialGroupLaboratory.loadState.status == RequestState.Pending,
        user: state.user.data,
        permissions: permissions,
        lookups: state.personnelRole.lookups,
        form: state.reduxForms.personnelRole,
        formState: state.personnelRole.formState,
        formProperties: state.personnelRole.formProperties,
        reduxFormState: state.reduxForms.formState.personnelRole,
        validationFailures: personnelRole
            ? state.personnelRole.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (dispatch): Partial<PersonnelRolePageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),
        loadPersonnelRole: bindActionCreators(
            PersonnelRoleActions.LoadPersonnelRoleById,
            dispatch
        ),
        clearPersonnelRole: bindActionCreators(
            PersonnelRoleActions.Clear,
            dispatch
        ),
        createPersonnelRole: bindActionCreators(
            PersonnelRoleActions.CreatePersonnelRole,
            dispatch
        ),
        savePersonnelRole: bindActionCreators(
            PersonnelRoleActions.SavePersonnelRole,
            dispatch
        ),
        validatePersonnelRole: bindActionCreators(
            PersonnelRoleActions.ValidatePersonnelRole,
            dispatch
        ),
        loadPersonnel: bindActionCreators(
            PersonnelActions.LoadPersonnelById,
            dispatch
        ),
        clearPersonnel: bindActionCreators(PersonnelActions.Clear, dispatch),
        loadTrialInstitutions: bindActionCreators(
            TrialInstitutionActions.LoadTrialInstitution,
            dispatch
        ),
        clearTrialInstitutions: bindActionCreators(
            TrialInstitutionActions.Clear,
            dispatch
        ),
        loadTrialGroups: bindActionCreators(
            TrialGroupActions.LoadTrialGroup,
            dispatch
        ),
        clearTrialGroups: bindActionCreators(TrialGroupActions.Clear, dispatch),
        loadInstitutionLaboratories: bindActionCreators(
            InstitutionLaboratoryActions.LoadInstitutionLaboratories,
            dispatch
        ),
        clearInstitutionLaboratories: bindActionCreators(
            InstitutionLaboratoryActions.Clear,
            dispatch
        ),
        loadTrialInstitutionLaboratories: bindActionCreators(
            TrialInstitutionLaboratoryActions.LoadTrialInstitutionLaboratories,
            dispatch
        ),
        clearTrialInstitutionLaboratories: bindActionCreators(
            TrialInstitutionLaboratoryActions.Clear,
            dispatch
        ),
        loadTrialGroupLaboratories: bindActionCreators(
            TrialGroupLaboratoryActions.LoadTrialGroupLaboratories,
            dispatch
        ),
        clearTrialGroupLaboratories: bindActionCreators(
            TrialGroupLaboratoryActions.Clear,
            dispatch
        ),
        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonnelRolePage);
